import { render, staticRenderFns } from "./ProductHeaderPremium.vue?vue&type=template&id=22f4c47b"
import script from "./ProductHeaderPremium.vue?vue&type=script&lang=js"
export * from "./ProductHeaderPremium.vue?vue&type=script&lang=js"
import style0 from "./ProductHeaderPremium.vue?vue&type=style&index=0&id=22f4c47b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports